// FAQ accordion
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      // Close all
      document.querySelectorAll('.faq-q').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        var ans = document.getElementById(b.getAttribute('aria-controls'));
        if (ans) ans.classList.remove('open');
      });
      // Open clicked (unless it was already open)
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        var ans = document.getElementById(btn.getAttribute('aria-controls'));
        if (ans) ans.classList.add('open');
      }
    });
  });
});

// Leaflet service-area map — loaded only when a city map is present.
var locationLeafletPromise = null;
function loadLocationLeaflet() {
  if (typeof L !== 'undefined') return Promise.resolve();
  if (locationLeafletPromise) return locationLeafletPromise;
  locationLeafletPromise = new Promise(function (resolve, reject) {
    if (!document.querySelector('link[data-leaflet]')) {
      var stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
      stylesheet.crossOrigin = '';
      stylesheet.dataset.leaflet = 'true';
      document.head.appendChild(stylesheet);
    }
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.crossOrigin = '';
    script.onload = function () { resolve(); };
    script.onerror = reject;
    document.head.appendChild(script);
  });
  return locationLeafletPromise;
}

function initLocationMaps() {
  document.querySelectorAll('.map-embed[data-lat][data-lng]').forEach(function (el) {
    var lat = parseFloat(el.getAttribute('data-lat'));
    var lng = parseFloat(el.getAttribute('data-lng'));
    if (!isFinite(lat) || !isFinite(lng)) return;
    var label = el.getAttribute('data-label') || '';
    var map = L.map(el, { scrollWheelZoom: false }).setView([lat, lng], 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    var marker = L.marker([lat, lng]).addTo(map);
    if (label) marker.bindPopup(label);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.map-embed[data-lat][data-lng]')) return;
  loadLocationLeaflet().then(initLocationMaps).catch(function () {
    document.querySelectorAll('.map-embed').forEach(function (el) {
      el.setAttribute('aria-label', 'Service area map is temporarily unavailable');
    });
  });
});
